import Vue from 'vue'
import Buefy from 'buefy'

Vue.use(Buefy, {
  "css": true,
  "materialDesignIcons": true,
  "materialDesignIconsHRef": "https://use.fontawesome.com/releases/v5.15.4/css/all.css",
  "async": true,
  "defaultIconPack": "fas"
})